module.exports = __webpack_public_path__ + "img/苏木.f0ef7807.jpg";